import React, { Component } from "react";

import { WindowEvent } from "./WindowEvent";

export interface IHandleKeyProps<T = any> {
    keyName: KeyboardEvent["key"];
    onPress: (context: T) => void;
    context?: T;
}

export class HandleKey extends Component<IHandleKeyProps> {
    public render() {
        return <WindowEvent type="keypress" onEvent={this.onKeyPress} />;
    }

    private onKeyPress = (event: KeyboardEvent) => {
        const { keyName, onPress, context } = this.props;
        if (event.key === keyName) {
            onPress(context);
        }
    };
}
